import { z } from 'zod';

const dateInterval = {
  from: z.date().optional(),
  to: z.date().optional(),
};

export const formSchema = z.object({
  material: z.string().optional(),
  invoiceNumber: z.string().optional(),
  startDate: z.date().optional(),
  endDate: z.date().optional(),
  createdAt: z.object(dateInterval).optional(),
});

export type FormSchema = z.infer<typeof formSchema>;